// extracted by mini-css-extract-plugin
export default {"companyContainer":"FL-z","companyImage":"GL-z","container":"HL-z","heading":"IL-z","darkText":"JL-z","smallHeading":"KL-z","darkBackground":"LL-z","whiteBackground":"ML-z"};